import type { Dispatch as ReduxDispatch } from '@reduxjs/toolkit';

import type { BaseAction } from '../@types/actions';
import type { RootState } from '../reducers';

export const EVENT_INIT = 'EVENT/INIT';
export type EVENT_INIT_TYPE = BaseAction<typeof EVENT_INIT> & {
  route: string;
  item?: any;
  retailer?: any;
};

export const EVENT_MESSAGE_PIPE = 'EVENT/MESSAGE_PIPE';
type EVENT_MESSAGE_PIPE_TYPE = BaseAction<typeof EVENT_MESSAGE_PIPE> & {
  message: string;
};

export const EVENT_TOGGLE_MENU = 'EVENT/TOGGLE_MENU';
type EVENT_TOGGLE_MENU_TYPE = BaseAction<typeof EVENT_TOGGLE_MENU>;

export const EVENT_HIDE_CHAT = 'EVENT/HIDE_CHAT';
export const EVENT_SHOW_CHAT = 'EVENT/SHOW_CHAT';

export const EVENT_PRODUCT_LIST_SORT_VISIBLE = 'EVENT/PRODUCT_LIST_SORT_VISIBLE';
type EVENT_PRODUCT_LIST_SORT_VISIBLE_TYPE = BaseAction<typeof EVENT_PRODUCT_LIST_SORT_VISIBLE>;

export const EVENT_SHOW_ECOM_MODAL = 'EVENT/SHOW_ECOM_MODAL';
type EVENT_SHOW_ECOM_MODAL_TYPE = BaseAction<typeof EVENT_SHOW_ECOM_MODAL>;

export const EVENT_SHOW_MESSAGE_MODAL = 'EVENT/SHOW_MESSAGE_MODAL';
type EVENT_SHOW_MESSAGE_MODAL_TYPE = BaseAction<typeof EVENT_SHOW_MESSAGE_MODAL>;

export const EVENT_HIDE_MESSAGE_MODAL = 'EVENT/HIDE_MESSAGE_MODAL';
type EVENT_HIDE_MESSAGE_MODAL_TYPE = BaseAction<typeof EVENT_HIDE_MESSAGE_MODAL>;

export type EVENT_ACTION =
  | EVENT_INIT_TYPE
  | EVENT_MESSAGE_PIPE_TYPE
  | EVENT_TOGGLE_MENU_TYPE
  | EVENT_PRODUCT_LIST_SORT_VISIBLE_TYPE
  | EVENT_SHOW_ECOM_MODAL_TYPE
  | EVENT_SHOW_MESSAGE_MODAL_TYPE
  | EVENT_HIDE_MESSAGE_MODAL_TYPE;

type Dispatch = ReduxDispatch<EVENT_ACTION>;

export const init = () => (dispatch: Dispatch, getState: () => RootState) => {
  const { routing, retailers } = getState();

  dispatch({ type: EVENT_INIT, route: routing.path, retailer: retailers.single });
};
export const toggleMenu = () => (dispatch: Dispatch) => dispatch({ type: EVENT_TOGGLE_MENU });

export const productListSortVisible = () => (dispatch: Dispatch) =>
  dispatch({ type: EVENT_PRODUCT_LIST_SORT_VISIBLE });

export const pipe = (message: string) => (dispatch: Dispatch) =>
  dispatch({ type: EVENT_MESSAGE_PIPE, message });

export const showEcomModal = () => (dispatch: Dispatch) =>
  dispatch({ type: EVENT_SHOW_ECOM_MODAL });

export const showMessageModal = () => (dispatch: Dispatch) =>
  dispatch({ type: EVENT_SHOW_MESSAGE_MODAL });
export const hideMessageModal = () => (dispatch: Dispatch) =>
  dispatch({ type: EVENT_HIDE_MESSAGE_MODAL });
